import { useContext } from "react"
import { TreeContext } from "./TreeProvider"
import { TreeProps } from "./Tree"

const CreateTreeEntryButton = ({
  index,
  id,
  setProps,
}: {
  index: number
  id: number
  setProps: (props: Partial<TreeProps>) => void
}) => {
  const { nCreate } = useContext(TreeContext)

  return (
    <div className="show-on-hover fs-5" style={{ minHeight: "10px" }}>
      <div
        className="ps-3 auto-hide clickable"
        style={{ minHeight: "5px" }}
        onClick={() => setProps({ n_create: nCreate + 1, entry_id: id, entry_index: index })}
      >
        ------
        <i className="bi bi-plus-circle-dotted" />
        ------
      </div>
    </div>
  )
}

export default CreateTreeEntryButton
